export default "__VITE_ASSET__BjLLEjrY__"